import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { ContentGroupType } from "../content/content.model";

import { ImagesPayload } from "./image.model";

const ACTION_PREFIX = "[Image Content]";
/**
 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
 */
export namespace ImageAction {
	/**
	 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
	 */
	export const getAll = createCachedGetAction(
		createAction(`${ACTION_PREFIX} Get All`, (payload: ContentGroupType) => ({
			payload,
			cacheKey: `${ACTION_PREFIX} Get All ${payload}`,
		}))
	);

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
	 */
	export const setImages = createAction(`${ACTION_PREFIX} Set Images ${SYNC_SUFFIX}`, (payload: ImagesPayload) => ({
		payload,
	}));

	export const getAllSuccess = createGetSuccessAction(
		createAction(`${ACTION_PREFIX} Get All Success`, (payload: ImagesPayload) => ({
			payload,
			cacheKey: `${ACTION_PREFIX} Get All Success ${payload.group}`,
		}))
	);

	export const getAllFail = createAction(`${ACTION_PREFIX} Get All Fail`, (error: AppError) => ({ payload: error }));
}
